module.exports = __webpack_public_path__ + "img/failure-img.3d19af87.png";